import React from "react"
import PropTypes from "prop-types"

const Internetandsocialnetworks = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 99.01 92.99"
    width={width}
    height={height}
  >
    <path
      fill="#56a8de"
      d="M57.42,33.11c.07-2.77,.17-5.55,.26-8.31-1.37-2.2-2.76-4.4-4.17-6.57-.35,2.58-.72,5.14-.86,7.61-.02,.28-.02,.56-.03,.84,1.33,2.29,2.67,4.57,4.05,6.83l.75-.4Z"
    />
    <path
      fill="#56a8de"
      d="M65.09,36.97c-.14-.23-.27-.45-.41-.67,.02,.62,.04,1.24,.06,1.86,.04-.45,.17-.85,.35-1.19Z"
    />
    <path
      fill="#56a8de"
      d="M1.32,92.41c6.98,1.15,14.7,.25,21.84,.16,7.62-.1,15.24-.22,22.86-.34,15.24-.24,30.48-.43,45.72-.74,.61-.01,1.1-.21,1.49-.51,.13,.18,.25,.36,.38,.54,1.79-.32,3.59-.58,5.4-.73-.03-.08-.06-.15-.1-.23-5.76-9.58-11.98-18.88-18.07-28.26,0,3.32,0,6.64,.07,9.96,3.03,4.81,6.1,9.6,9.28,14.29-14.63,.19-29.27,.47-43.91,.72-7.62,.13-15.24,.26-22.86,.41-5.33,.1-10.95-.24-16.4,.15,3.11-4.77,6.09-9.63,9.04-14.52,.05-1.53,.11-3.07,.2-4.6-.6-.94-1.09-1.94-1.42-2.99-4.56,7.5-9.06,15.04-13.21,22.74-.01,.02-.02,.04-.03,.06-.02,0-.04,0-.07,.01-1.88,.37-2.09,3.56-.2,3.88Z"
    />
    <path
      fill="#56a8de"
      d="M34.33,40.3c.03-1.82,1.6-2.57,2.93-2.26,2.77-4.56,5.52-9.13,8.23-13.71-.03-.64-.07-1.27-.1-1.91-.1-2.46-.02-4.99,.07-7.55-4.87,7.76-9.56,15.65-14.23,23.54,0,3.2-.02,6.41-.05,9.61,1.04-1.71,2.08-3.42,3.12-5.13,0-.86,0-1.73,.02-2.59Z"
    />
    <path
      fill="#56a8de"
      d="M74.39,61.85c0-3.08,.07-6.17,.24-9.23-.09-.15-.19-.3-.28-.45-1.19-1.9-2.36-3.81-3.53-5.72,.09,3.36,.14,6.73,.27,10.09,1.1,1.77,2.21,3.54,3.31,5.31Z"
    />
    <polygon
      fill="#1e1e1c"
      points="35.21 41.74 36.94 40.82 36.97 40.82 36.97 49.42 38.27 49.42 38.27 39.58 37.12 39.58 35.94 40.2 34.95 40.73 35.15 41.5 35.21 41.74"
    />
    <path
      fill="#1e1e1c"
      d="M40.28,63.32h.12v-1.11h-4.47v-.03l.8-.73c1.82-1.74,3.07-3.08,3.36-4.59,.04-.23,.07-.46,.07-.7,0-.29-.05-.57-.13-.85-.3-1.09-1.21-2.01-2.92-2.01-1.07,0-1.99,.38-2.67,.9-.05,.04-.1,.07-.15,.1l.16,.35,.27,.59c.46-.38,1.21-.83,2.11-.83,1.49,0,1.98,.92,1.98,1.92-.02,1.49-1.16,2.76-3.71,5.15l-.4,.38-.66,.63v.82h6.23Z"
    />
    <path
      fill="#1e1e1c"
      d="M40.4,77.21v-1.11h-4.47v-.03l.8-.73c2.1-2,3.43-3.47,3.43-5.29,0-1.41-.9-2.86-3.05-2.86-.82,0-1.55,.22-2.15,.55-.24,.13-.47,.28-.67,.45l.43,.94c.08-.07,.19-.14,.29-.21,.46-.32,1.08-.62,1.82-.62,1.49,0,1.98,.92,1.98,1.92-.01,1.45-1.12,2.7-3.53,4.98-.06,.06-.12,.11-.18,.17l-1.06,1.02v.82h6.36Z"
    />
    <path
      fill="#1e1e1c"
      d="M38.27,86.84v-5.58h-1.15l-1.59,.84-.59,.31,.26,1.01,.36-.19,1.37-.73h.03v4.44c.43-.04,.87-.07,1.3-.11Z"
    />
    <path
      fill="#1e1e1c"
      d="M70.21,25.12h-4.07v-.03l.72-.66c1.91-1.82,3.12-3.15,3.12-4.81,0-1.28-.82-2.6-2.77-2.6-1.04,0-1.94,.39-2.56,.91l.39,.85c.42-.34,1.1-.76,1.92-.76,1.35,0,1.8,.84,1.8,1.75-.01,1.35-1.06,2.51-3.37,4.68l-.96,.92v.74h5.78v-1.01Z"
    />
    <polygon
      fill="#1e1e1c"
      points="67.09 40.28 67.09 43.16 68.27 43.16 68.27 42.25 68.27 35.52 68.27 34.2 67.23 34.2 65.25 35.25 65.48 36.17 67.06 35.33 67.09 35.33 67.09 35.51 67.09 40.28"
    />
    <polygon
      fill="#1e1e1c"
      points="65.48 53.21 67.06 52.37 67.09 52.37 67.09 60.19 68.27 60.19 68.27 52.06 68.27 51.24 67.75 51.24 67.23 51.24 65.25 52.29 65.48 53.21"
    />
    <polygon
      fill="#1e1e1c"
      points="65.48 70.25 67.06 69.41 67.09 69.41 67.09 77.23 68.27 77.23 68.27 68.28 67.23 68.28 65.25 69.32 65.48 70.25"
    />
    <path
      fill="#1e1e1c"
      d="M69.1,85.78c-.45-.37-1.06-.62-1.89-.62s-1.5,.23-2.07,.57c1.32,0,2.64,.02,3.96,.06Z"
    />
    <polygon
      fill="#1e1e1c"
      points="74.95 51.16 76.46 50.35 76.49 50.35 76.49 55.55 76.49 57.87 77.63 57.87 77.63 57.34 77.63 49.27 76.62 49.27 74.78 50.24 74.72 50.27 74.77 50.45 74.95 51.16"
    />
    <path
      fill="#1e1e1c"
      d="M79.49,74.9v-.97h-3.91v-.03l.7-.64c1.5-1.43,2.55-2.56,2.88-3.79,.07-.27,.12-.54,.12-.83,0-1.12-.66-2.25-2.17-2.46-.16-.02-.31-.04-.49-.04-.87,0-1.61,.28-2.19,.68-.09,.06-.19,.12-.27,.19l.29,.62,.09,.2c.4-.33,1.06-.73,1.85-.73,1.3,0,1.73,.81,1.73,1.68-.01,1.3-1.02,2.41-3.24,4.5l-.27,.26-.66,.63v.72h5.55Z"
    />
    <path
      fill="#1e1e1c"
      d="M78.31,86.23s0,0,0,0c.3,.02,.6,.04,.89,.07,.04-.2,.06-.4,.06-.61,0-1.23-.79-2.5-2.66-2.5-.6,0-1.14,.14-1.61,.36-.32,.14-.61,.31-.85,.51l.37,.82c.14-.12,.32-.23,.52-.35,.37-.21,.81-.38,1.33-.38,1.3,0,1.73,.81,1.73,1.68,0,.13-.02,.25-.04,.38,.09,0,.17,.01,.26,.02Z"
    />
    <polygon
      fill="#1e1e1c"
      points="49.31 1.91 49.36 1.91 49.36 12.62 49.36 15.1 51.36 15.1 51.36 15 51.36 2.94 51.36 0 50.69 0 49.6 0 46.26 1.77 46.66 3.32 49.31 1.91"
    />
    <polygon
      fill="#1e1e1c"
      points="48.36 19.45 48.51 19.37 49.31 18.94 49.36 18.94 49.36 20.9 49.36 32.14 51.36 32.14 51.36 24.5 51.36 17.04 49.6 17.04 46.26 18.8 46.66 20.36 48.36 19.45"
    />
    <path
      fill="#1e1e1c"
      d="M52.97,49.17h1.65v-1.7h-6.86v-.05l1.22-1.11c1.88-1.79,3.34-3.3,4.24-4.8,.65-1.07,1.02-2.14,1.02-3.31,0-1.31-.52-2.65-1.66-3.5-.74-.55-1.72-.9-3.01-.9-1.42,0-2.67,.43-3.65,1.05-.24,.15-.46,.31-.67,.48l.66,1.44s.02-.01,.02-.02c.71-.58,1.85-1.26,3.22-1.26,2.28,0,3.03,1.42,3.03,2.95-.02,2.27-1.78,4.22-5.67,7.88,0,0-.01,.01-.02,.02l-1.62,1.56v1.25h8.1Z"
    />
    <path
      fill="#1e1e1c"
      d="M54.62,64.51h-6.86v-.05l1.22-1.11c3.22-3.07,5.26-5.32,5.26-8.11,0-1.62-.79-3.29-2.57-4.01-.59-.24-1.29-.38-2.1-.38-.48,0-.95,.05-1.39,.14-1.16,.24-2.17,.75-2.94,1.39l.66,1.44c.71-.58,1.86-1.28,3.24-1.28,2.28,0,3.03,1.42,3.03,2.95-.02,2.28-1.78,4.23-5.68,7.9l-1.62,1.56v1.25h9.75v-1.7Z"
    />
    <path
      fill="#1e1e1c"
      d="M52.35,83.25h2.27v-1.7h-6.86v-.05l1.22-1.11c1.09-1.04,2.03-1.98,2.82-2.89,1.54-1.77,2.44-3.38,2.44-5.22,0-2.16-1.39-4.39-4.68-4.39-1.76,0-3.27,.65-4.32,1.53l.66,1.44c.71-.58,1.86-1.28,3.24-1.28,2.28,0,3.03,1.42,3.03,2.95-.01,1.13-.45,2.18-1.37,3.4-.93,1.24-2.35,2.65-4.31,4.5l-.32,.31-1.3,1.25v1.25h7.48Z"
    />
    <path
      fill="#1e1e1c"
      d="M51.36,86.05v-.87h-1.76l-2.02,1.07c1.26-.07,2.52-.14,3.78-.2Z"
    />
    <polygon
      fill="#1e1e1c"
      points="22.19 17.52 22.24 17.52 22.24 30.72 24.24 30.72 24.24 15.62 22.47 15.62 19.14 17.38 19.54 18.94 22.19 17.52"
    />
    <path
      fill="#1e1e1c"
      d="M25.68,47.75h1.82v-1.7h-6.86v-.05l1.22-1.11c3.22-3.07,5.26-5.32,5.26-8.11,0-1.35-.55-2.73-1.76-3.58-.72-.5-1.69-.81-2.91-.81-1.76,0-3.27,.65-4.32,1.53l.66,1.44c.71-.58,1.86-1.28,3.24-1.28,2.24,0,3,1.37,3.02,2.87,0,.03,0,.05,0,.08-.02,2.15-1.61,4.02-5.06,7.3-.06,.06-.11,.11-.17,.17-.15,.15-.29,.28-.45,.43l-.57,.54-1.05,1.01v1.25h7.93Z"
    />
    <path
      fill="#1e1e1c"
      d="M27.5,64.79v-1.7h-6.86v-.05l1.22-1.11c.9-.86,1.7-1.65,2.4-2.41,1.46-1.59,2.44-3.04,2.75-4.61,.07-.36,.11-.72,.11-1.09,0-1.65-.81-3.33-2.66-4.04-.57-.22-1.24-.35-2.02-.35-1.12,0-2.13,.26-2.99,.68-.5,.24-.95,.53-1.33,.85l.54,1.17,.12,.27c.71-.58,1.86-1.28,3.24-1.28,.59,0,1.08,.1,1.48,.27,1.13,.48,1.55,1.55,1.55,2.68-.02,2.28-1.78,4.23-5.68,7.9l-1.62,1.56v1.25h9.75Z"
    />
    <path
      fill="#1e1e1c"
      d="M27.5,80.13h-6.86v-.05l1.22-1.11c3.22-3.07,5.26-5.32,5.26-8.11,0-2.16-1.39-4.39-4.68-4.39-.97,0-1.85,.2-2.63,.52-.64,.27-1.22,.61-1.69,1.01l.47,1.04,.18,.4c.71-.58,1.86-1.28,3.24-1.28,2.28,0,3.03,1.42,3.03,2.95-.02,2.28-1.78,4.23-5.68,7.9l-1.62,1.56v1.25h9.75v-1.7Z"
    />
    <path
      fill="#1e1e1c"
      d="M22.24,86.48c.33,0,.67,0,1-.01,.33,0,.66-.01,.99-.01v-2.7h-1.76l-3.34,1.77,.26,1.03h0c.1,0,.2,0,.29,0,.3-.01,.6-.02,.9-.03l1.59-.85h.05v.82h0Z"
    />
    <polygon
      fill="#1e1e1c"
      points="59.09 12.78 59.65 12.49 60.42 12.07 60.48 12.07 60.48 12.29 60.48 28.88 63.02 28.88 63.02 13.16 63.02 9.65 60.78 9.65 56.53 11.9 57.04 13.88 59.09 12.78"
    />
    <polygon
      fill="#1e1e1c"
      points="57.37 35.39 57.71 35.21 60.42 33.76 60.48 33.76 60.48 39.7 60.48 50.57 63.02 50.57 63.02 43.75 63.02 33.53 63.02 31.34 61.69 31.34 60.78 31.34 57.42 33.11 56.66 33.51 56.53 33.59 57.04 35.57 57.37 35.39"
    />
  </svg>
)

Internetandsocialnetworks.propsTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

Internetandsocialnetworks.defaultProps = {
  width: "60px",
  height: "60px",
}

export { Internetandsocialnetworks }
